export const CART_ID_DESKTOP = 'cart-container-desktop';
export const CART_ID_MOBILE = 'cart-container-mobile';
